module.exports = __webpack_public_path__ + "static/media/stop-circle.fe44eea7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wcce/stop-circle.svg
// module id = 914
// module chunks = 0